module.exports = __webpack_public_path__ + "img/redInfo.5b3b64b9.svg";